import { Game } from 'config/types/game'
import { useMemo } from 'react'
import { useClientIpInfo, useProviderInfo, useValidatePlayToken } from 'state/app/hooks'
import { useAuth } from 'state/auth/hooks'
import { useTokenSelected } from 'state/session/hooks'

const useValidateGame = (game: Game) => {
  const { isSigned } = useAuth()

  const playToken = useTokenSelected()
  const { isBlackList } = useValidatePlayToken(playToken)
  const { country } = useClientIpInfo()
  const provider = useProviderInfo(game.providerCode)
  const isBlockedCountry = provider?.blacklistCountry?.includes(country)

  return useMemo(
    () => !isBlockedCountry && !game.isMaintenance && !isBlackList && isSigned,
    [isBlockedCountry, game.isMaintenance, isBlackList, isSigned],
  )
}

export default useValidateGame
